// extracted by mini-css-extract-plugin
module.exports = {"title":"success_title__262X7","paragraph":"success_paragraph__IMgtL","italic":"success_italic__1QEZl","card":"success_card__3QSTx","container":"success_container__1Rs1p"};